<template>
<div>
    <v-calendar
          ref="calendar"
          v-model="today"
          color="primary"
          :type="type"
        >
        <!-- the events at the top (all-day) -->
        <template v-slot:dayHeader="{ date }">
        <template v-for="event in eventsMap[date]">
            <!-- all day events don't have time -->
            <div
            v-if="!event.duration"
            :key="event.title"
            class="my-event"
            @click="open(event)"
            v-html="event.title"
            ></div>
        </template>
        </template>
        <!-- the events at the bottom (timed) -->
        <template v-slot:dayBody="{ date, timeToY, minutesToPixels }">
        <template v-for="event in eventsMap[date]">
            <!-- timed events -->
            <div
            v-if="event.time"
            :key="event.title"
            :style="{ top: timeToY(event.time) + 'px', height: minutesToPixels(event.duration) + 'px' }"
            class="my-event with-time"
            @click="open(event)"
            v-html="event.title"
            ></div>
        </template>
        </template>
        <template v-slot:day="{ date }">
        <template v-for="event in eventsMap[date]">
            <v-menu
            :key="event.title"
            v-model="event.open"
            full-width
            offset-x
            >
            <template v-slot:activator="{ on }">
                <div
                v-ripple
                class="my-event"
                v-on="on"
                v-html="event.title"
                ></div>
            </template>
            <v-card
                color="grey lighten-4"
                min-width="350px"
                flat
            >
                <v-toolbar
                color="primary"
                dark
                >
                <v-btn icon>
                    <v-icon>edit</v-icon>
                </v-btn>
                <v-toolbar-title v-html="event.title"></v-toolbar-title>
                <v-spacer></v-spacer>
                <v-btn icon>
                    <v-icon>favorite</v-icon>
                </v-btn>
                <v-btn icon>
                    <v-icon>more_vert</v-icon>
                </v-btn>
                </v-toolbar>
                <v-card-title primary-title>
                <span v-html="event.details"></span>
                </v-card-title>
                <v-card-actions>
                <v-btn
                    flat
                    color="secondary"
                >
                    Cancel
                </v-btn>
                </v-card-actions>
            </v-card>
            </v-menu>
        </template>
        </template>
    </v-calendar>

  <v-dialog
    v-model="dialog"
    max-width="290">

    <v-card>
      <v-card-title class="headline">Detail Jadwal</v-card-title>
      <v-divider></v-divider>
      <v-card-text>
        <p>{{nama}}</p>
        <p>Gedung : {{gedung}}</p>
        <p>Lokasi : {{lokasi}}</p>
        <p>Ruangan : {{ruangan}}</p>
        <p>Waktu : {{waktu}}</p>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>

        <v-btn
          color="green darken-1"
          flat="flat"
          @click="dialog = false"
        >
          Kembali
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>

  <!--<v-container fluid>-->
    <!--<v-row >-->
      <!--<v-col cols="12">-->
        <!--<v-row>-->
          <!--<v-col class="md-6">-->
            <!--<v-btn @click="$refs.calendar.prev()">-->
              <!--<v-icon-->
                <!--dark-->
                <!--left-->
              <!--&gt;-->
                <!--fa-chevron-left-->
              <!--</v-icon>-->
              <!--Prev-->
            <!--</v-btn>-->
          <!--</v-col>-->
          <!--<v-col class="md-6">-->
            <!--<v-btn @click="$refs.calendar.next()">-->
              <!--Next-->
              <!--<v-icon-->
                <!--right-->
                <!--dark-->
              <!--&gt;-->
                <!--fa-chevron-right-->
              <!--</v-icon>-->
            <!--</v-btn>-->
          <!--</v-col>-->
        <!--</v-row>-->
      <!--</v-col>-->
    <!--</v-row>-->
  <!--</v-container>-->

  <!--<v-container fluid>-->
    <!--<v-layout row>-->
      <!--<v-flex xs6>-->
        <!--<v-btn @click="$refs.calendar.prev()">-->
          <!--<v-icon-->
            <!--dark-->
            <!--left-->
            <!--&gt;-->
            <!--fa-chevron-left-->
          <!--</v-icon>-->
          <!--Prev-->
        <!--</v-btn>-->
      <!--</v-flex>-->
      <!--<v-flex xs6>-->
        <!--<v-btn @click="$refs.calendar.next()">-->
          <!--Next-->
          <!--<v-icon-->
            <!--right-->
            <!--dark-->
            <!--&gt;-->
            <!--fa-chevron-right-->
          <!--</v-icon>-->
        <!--</v-btn>-->
      <!--</v-flex>-->
    <!--</v-layout>-->
  <!--</v-container>-->
</div>
</template>

<script>
import moment from 'moment'

export default {
    props: ["event", "type"],
    data(){
        return{
            today: moment(Date.now()).format('YYYY-MM-DD HH:mm:ss').substring(0, 10),
            end: '',
            dialog: false,
            nama: "",
            gedung : "",
            ruangan : "",
            lokasi : "",
            waktu : ""
        }
    },
    computed: {
        eventsMap () {
        const map = {}
        this.event.forEach(e => (map[e.date] = map[e.date] || []).push(e))
        console.log(map)
        return map}
    },
    mounted () {
      this.$refs.calendar.scrollToTime('08:00')
    },

  methods: {
    open (event) {
      this.dialog = true
      this.nama = event.details.substring(10,event.details.length)
      this.gedung = event.gedung
      this.lokasi = event.lokasi
      this.ruangan = event.ruangan
      this.waktu = event.time + " - " + event.selesai
    }
  }
    
}
</script>

<style lang="stylus" scoped>
  .my-event {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    border-radius: 2px;
    background-color: #1867c0;
    color: #ffffff;
    border: 1px solid #1867c0;
    width: 100%;
    font-size: 12px;
    padding: 3px;
    cursor: pointer;
    margin-bottom: 1px;
  }

   &.with-time {
      position: absolute;
      right: 4px;
      margin-right: 0px;
    }
</style>